/* eslint-disable jsx-a11y/no-static-element-interactions, we need to use an onClick within a table. */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import numeral from 'numeral';
import ShowComponent from '../../hocs/ShowComponent';
import OverviewTableSelectColumnComponent from './OverviewTableSelectColumnComponent';
import LoaderComponent from '../../shared_components/LoaderComponent';
import ChooseProductMobileComponent from '../../shared_components/ChooseProductMobileComponent';
import OverviewTableRowsComponent from './OverviewTableRowsComponent';
import OverviewTableSortingHeadComponent from './OverviewTableSortingHeadComponent';

@withRouter
@ShowComponent
@observer
class OverviewTableComponent extends React.Component {
  constructor(props) {
    super(props);

    this.getFormattedInterestForLabel = this.getFormattedInterestForLabel.bind(this);
  }

  componentDidMount() {
    const { sortLabelInterestsByTermInterest, secondOverviewTableColumnFixedRateTerm } = this.props.OverviewData;

    $(document).ready(() => {
      if ($(document).width() > 540) {
        sortLabelInterestsByTermInterest(secondOverviewTableColumnFixedRateTerm);
      }
    });
  }

  getFormattedInterestForLabel(label, index, interestType) {
    let labelInterest = numeral(label.interests[index][interestType] / 100).format('%0.00');

    if (label.interests[index][interestType] === 0) {
      labelInterest = '-';
    }

    return labelInterest;
  }

  render() {
    const {
      labelInterests,
      sortLabelInterestsByInitialInterest,
      sortLabelInterestsByTermInterest,
      sortLabelInterestsByTermInterestAvailable,
      showAllProviders,
      sortedOverviewTableColumn,
      getFixedRateTermIndex,
      firstOverviewTableColumnFixedRateTerm,
      secondOverviewTableColumnFixedRateTerm,
      setFirstOverviewTableColumnFixedRateTerm,
      setSecondOverviewTableColumnFixedRateTerm,
      openSortingDropdown,
      setOpenSortingDropdown,
      closeOpenSortingDropdown,
      allFixedRateTerms,
      labelInterestsLoading,
      getNewLabelInterests,
    } = this.props.OverviewData;

    const { informationBoxData } = this.props.InformationBoxData;

    /* If showAllProviders is false, pick first 10 labelInterests */
    let labelInterestsSelection = labelInterests;

    if (!showAllProviders) {
      labelInterestsSelection = labelInterests.filter((label, index) => index < 10);
    }

    const firstColumnIndex = getFixedRateTermIndex(firstOverviewTableColumnFixedRateTerm);
    const secondColumnIndex = getFixedRateTermIndex(secondOverviewTableColumnFixedRateTerm);

    const sortedClassName = 'overview-container__sorted-column bold';

    let labelInterestsLoadingClassName;
    if (labelInterestsLoading) {
      labelInterestsLoadingClassName = 'overview-container__loading-interest-rows';
    }

    let partOfTable = true;

    const table = (
      <table>
        <thead>
          <tr>
            <th colSpan={2} />
            <OverviewTableSelectColumnComponent
              partOfTable={partOfTable}
              classNames={'overview-container__sort-first-column-list overview-container__sort-column-list'}
              dropdownListItemClassName={'overview-container__sort-second-column-list__item'}
              fixedRateTerm={firstOverviewTableColumnFixedRateTerm}
              otherFixedRateTerm={secondOverviewTableColumnFixedRateTerm}
              setFirstOverviewTableColumnFixedRateTerm={setFirstOverviewTableColumnFixedRateTerm}
              setSecondOverviewTableColumnFixedRateTerm={setSecondOverviewTableColumnFixedRateTerm}
              sortLabelInterestsByTermInterest={sortLabelInterestsByTermInterest}
              openSortingDropdown={openSortingDropdown}
              setOpenSortingDropdown={setOpenSortingDropdown}
              closeOpenSortingDropdown={closeOpenSortingDropdown}
              order={'first'}
              allFixedRateTerms={allFixedRateTerms}
	      getNewLabelInterests={getNewLabelInterests}
            />

            <OverviewTableSelectColumnComponent
              partOfTable={partOfTable}
              classNames={'overview-container__sort-second-column-list overview-container__sort-column-list'}
              dropdownListItemClassName={'overview-container__sort-second-column-list__item'}
              fixedRateTerm={secondOverviewTableColumnFixedRateTerm}
              otherFixedRateTerm={firstOverviewTableColumnFixedRateTerm}
              setFirstOverviewTableColumnFixedRateTerm={setFirstOverviewTableColumnFixedRateTerm}
              setSecondOverviewTableColumnFixedRateTerm={setSecondOverviewTableColumnFixedRateTerm}
              sortLabelInterestsByTermInterest={sortLabelInterestsByTermInterest}
              openSortingDropdown={openSortingDropdown}
              setOpenSortingDropdown={setOpenSortingDropdown}
              closeOpenSortingDropdown={closeOpenSortingDropdown}
              order={'second'}
              allFixedRateTerms={allFixedRateTerms}
	      getNewLabelInterests={getNewLabelInterests}
            />
            <th colSpan={3} />
          </tr>
        </thead>
        <OverviewTableSortingHeadComponent
          ModalData={this.props.ModalData}
          sortedOverviewTableColumn={sortedOverviewTableColumn}
          firstOverviewTableColumnFixedRateTerm={firstOverviewTableColumnFixedRateTerm}
          sortLabelInterestsByInitialInterest={sortLabelInterestsByInitialInterest}
          sortedClassName={sortedClassName}
          informationBoxData={informationBoxData}
          sortLabelInterestsByTermInterest={sortLabelInterestsByTermInterest}
          secondOverviewTableColumnFixedRateTerm={secondOverviewTableColumnFixedRateTerm}
          sortLabelInterestsByTermInterestAvailable={sortLabelInterestsByTermInterestAvailable}
        />
        <tbody>
          <tr className="loader-container">
            <LoaderComponent
              show={labelInterestsLoading}
            />
          </tr>
          {labelInterestsSelection.map((label, index) => (
            <OverviewTableRowsComponent
              key={index}
              label={label}
              labelInterestsSelection={labelInterestsSelection}
              sortedOverviewTableColumn={sortedOverviewTableColumn}
              firstOverviewTableColumnFixedRateTerm={firstOverviewTableColumnFixedRateTerm}
              firstColumnIndex={firstColumnIndex}
              secondOverviewTableColumnFixedRateTerm={secondOverviewTableColumnFixedRateTerm}
              secondColumnIndex={secondColumnIndex}
              labelInterestsLoadingClassName={labelInterestsLoadingClassName}
              sortedClassName={sortedClassName}
            />))}
        </tbody>
      </table>
    );

    /* Set partOfTable false. OverviewTableSelectColumnComponent will we rendered with a div instead of th element. */
    partOfTable = false;

    const mobileList = (
      <div className="row">
        <ChooseProductMobileComponent
          labelInterests={labelInterestsSelection}
          calculateBenefit={(labelId) => { this.props.history.push(`bereken/${labelId}`); }}
          sortedFixedRateTerm={this.props.OverviewData.secondOverviewTableColumnFixedRateTerm}
          getFixedRateTermIndex={this.props.OverviewData.getFixedRateTermIndex}
        >
          {/* Use one of the table select columns. */}
          {/* With otherFixedRateTerm === -1, OverviewTableSelectColumnComponent will show all frts. */}
          <OverviewTableSelectColumnComponent
            partOfTable={partOfTable}
            classNames={'choose-product__select-frt'}
            dropdownListClassName={'choose-product-table__dropdown-list'}
            dropdownListItemClassName={'choose-product-table__dropdown-list-item'}
            fixedRateTerm={secondOverviewTableColumnFixedRateTerm}
            otherFixedRateTerm={-1}
            setFirstOverviewTableColumnFixedRateTerm={setFirstOverviewTableColumnFixedRateTerm}
            setSecondOverviewTableColumnFixedRateTerm={setSecondOverviewTableColumnFixedRateTerm}
            sortLabelInterestsByTermInterest={sortLabelInterestsByTermInterest}
            openSortingDropdown={openSortingDropdown}
            setOpenSortingDropdown={setOpenSortingDropdown}
            closeOpenSortingDropdown={closeOpenSortingDropdown}
            order={'second'}
            allFixedRateTerms={allFixedRateTerms}
          />
        </ChooseProductMobileComponent>
      </div>
    );

    let component;
    const documentWidth = $(document).width();
    if (documentWidth > 800) {
      component = table;
    } else if (documentWidth <= 800) {
      component = mobileList;
    }

    return component;
  }
}

OverviewTableComponent.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  OverviewData: PropTypes.shape({
    labelInterestsLoading: PropTypes.bool,
    firstOverviewTableColumnFixedRateTerm: PropTypes.number,
    secondOverviewTableColumnFixedRateTerm: PropTypes.number,
    sortedOverviewTableColumn: PropTypes.string,
    getFixedRateTermIndex: PropTypes.func,
    openSortingDropdown: PropTypes.string,
    allFixedRateTerms: PropTypes.arrayOf(PropTypes.number),
    setFirstOverviewTableColumnFixedRateTerm: PropTypes.func,
    setSecondOverviewTableColumnFixedRateTerm: PropTypes.func,
    setOpenSortingDropdown: PropTypes.func,
    closeOpenSortingDropdown: PropTypes.func,
    sortLabelInterestsByInitialInterest: PropTypes.func,
    sortLabelInterestsByTermInterest: PropTypes.func,
    sortLabelInterestsByTermInterestAvailable: PropTypes.func,
    getNewLabelInterests: PropTypes.func,
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
    showAllProviders: PropTypes.bool,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
};

OverviewTableComponent.defaultProps = {
  history: {
    push: () => {},
  },
  OverviewData: {
    labelInterestsLoading: false,
    allFixedRateTerms: [],
    setFirstOverviewTableColumnFixedRateTerm: () => {},
    setSecondOverviewTableColumnFixedRateTerm: () => {},
    getNewLabelInterests: () => {},
    closeOpenSortingDropdown: () => {},
    firstOverviewTableColumnFixedRateTerm: 0,
    secondOverviewTableColumnFixedRateTerm: 0,
    sortedOverviewTableColumn: '',
    labelInterests: [],
    showAllProviders: false,
    openSortingDropdown: '',
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  ModalData: {
    openModal: () => {},
  },
};

export default inject('OverviewData', 'InformationBoxData', 'ModalData')(OverviewTableComponent);
